export default __webpack_public_path__ + "static/media/sports04.1188cfb0.jpg";